// namespace: mixture
// import { getScmCompanyConf } from '@/servers/prod/conf';

import { saveItemGroupPicture } from '@/api/prod/center';

// 获取配置
export const confModule = {
  state: {
    // 是否开启库存上传（由公司平台配置派生）
    isStockUpload: true,
    // 公司平台配置原始数据（页面加载时拉取后写入）
    scmCompanyConf: null,
  },
  mutations: {
    // 通用数据写入，使用方式：commit('mixture/confModule/setData', { key, value })
    setData(state, { key, value }) {
      state[key] = value;
    },
  },
  // actions: {
  //   async reqConfData({ commit }) {
  //     const data = await getScmCompanyConf();
  //     commit('setData', { key: 'isStockUpload', value: !!data && data.pushItemToErp === 1 && data.ifSyncItemToErp === 1 });
  //   },
  // },
};

// 用作临时缓存
export const caches = {
  state: {
    // 商品新增 添加套图
    groupImages: [],
  },
  mutations: {
    caches_add(state, event) {
      state[event.type] = event.data;
    },
    caches_remove(state, event) {
      state[event.type] = [];
    },
  },
  actions: {
    async caches_save({ commit, state, rootState }, event) {
      let data = state[event.type] || [];
      if (!data.length) return;
      await saveItemGroupPicture({
        companyId: rootState.user.userInfo.companyId,
        baseItemId: event.data,
        scmItemPictureList: (state[event.type] || []).map((item, index) => {
          return {
            ...item,
            baseItemId: event.data,
          };
        }),
        pictureIds: [],
      });
    },
  },
};
